module.exports = __webpack_public_path__ + "img/1.0bfc2f5a.png";